import toastr from 'react-hot-toast';
import { useQuery } from 'react-query';
import { fetchWrapper } from 'utils/fetchWrapper';
import { CACHE_AND_STALE_TIME } from 'constants/index';
import {
  generateIncludeQuery,
  generateURL,
} from 'utilities/hooks/urlGeneration';
import { QueryOptions, SPARK_RESOURCE_TYPES } from 'constants/common';

import type { SingleMemoryResponse } from 'types/Memory';

import { createSingleJoinedMemory } from 'helpers/spark';

const getMemoryByID = (memoryID: string | null | undefined) => {
  if (!memoryID) {
    Promise.reject('memory ID not  found');
    return;
  }

  const queryArray = [
    generateIncludeQuery([
      'memoryCategories',
      'memoryFiles.file',
      'marketplaceAccount',
      'memoryRatings',
      'memoryFavourites',
      'memoryImages',
    ]),
  ];
  const url = generateURL(SPARK_RESOURCE_TYPES.MEMORIES, queryArray, memoryID);

  return fetchWrapper<SingleMemoryResponse>({
    url: url,
    method: 'GET',
  });
};

export function useMemoryByID(
  memoryID?: string | null,
  options?: QueryOptions
) {
  let toastId: string | undefined;
  const queryResult = useQuery(
    ['memory', memoryID],
    () => getMemoryByID(memoryID),
    {
      onError: (error) => {
        if (error instanceof Error) {
          if (!toastId) {
            toastId = toastr.error(`failed to Fetch Memory: ${error.message}`, {
              id: `failed-fetching-memory: ${memoryID}`,
            });
          }
        }
      },
      enabled: Boolean(Boolean(memoryID) || options?.enabled),
      ...CACHE_AND_STALE_TIME,
    }
  );

  const { data: memoryResponse } = queryResult;
  const { data: memory } = memoryResponse || {};
  const joinedMemory = createSingleJoinedMemory(memoryResponse);

  return {
    memory,
    joinedMemory,
    ...queryResult,
  };
}
